import { mapValues } from 'lodash';

export const wrapWithDispatch = (actionCreators, dispatch) => {
    return mapValues(actionCreators, actionCreator => (...otherProps) => {
        dispatch(actionCreator(...otherProps));
    });
};
